import { css } from '@emotion/react';

export default $ => css`
  .m-0 > .file-field > .file-input {
    margin: 0 !important;
  }

  .file-input {
    display: flex;
    position: absolute;
    flex-wrap: nowrap;
    width: stretch;
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px 8px 0 !important;
    border: 1px solid ${$.gray100};

    .file-input-required-icon {
      position: absolute;
      top: 4px;
      left: 4px;
      background-color: ${$.dangerMain};
      font-size: 10px;
      color: ${$.white};
      padding: 2px;
      border-radius: 2px;
    }

    .file-input-toolbar {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .file-input-toolbar > label.file-input-label {
      margin: 0;
      white-space: nowrap;

      > input[type='file'] {
        opacity: 0;
        width: 1px;
      }
    }

    > .file-input-info {
      display: flex;
      gap: 8px;
      align-items: center;

      > .file-input-info-text {
        margin-left: 68px;
        display: flex;
        flex-direction: column;

        > .file-input-title {
          font-weight: 600;
        }

        > .file-input-name,
        > .file-input-placeholder {
        }
      }

      > .input-group-text {
        position: absolute;
        border: none;
        max-width: 15em;
        text-overflow: ellipsis;
        overflow: hidden;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 60px;
        border-radius: 0;

        > i.fa {
          font-size: 20px;
        }
      }
    }
  }
`;
